import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/regions',
    name: RouteName.Regions,
    component: () => import('@/pages/Regions/RegionsList'),
    meta: {
      breadcrumb: {
        label: 'Регионы',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/regions/create',
    name: 'regionCreate',
    component: () => import('@/pages/Regions/RegionsCreate'),
    meta: {
      breadcrumb: {
        label: 'Новый регион',
        parent: RouteName.Regions,
      },
    },
  },
  {
    path: '/regions/:id',
    name: 'regionEdit',
    component: () => import('@/pages/Regions/RegionsSingle'),
    props: { isEdit: false },
    meta: {
      breadcrumb: {
        label: 'Редактирование региона',
        parent: RouteName.Regions,
      },
    },
  },
]
